

export const scrollToClass =(className, vhOffset) => {
    const element = document.querySelector(`.${className}`);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top + window.scrollY; 
      const offsetInPixels = (vhOffset * window.innerHeight) / 100;
      const adjustedPosition = elementPosition - offsetInPixels;

      window.scrollTo({
        top: adjustedPosition,
        behavior: 'smooth'
      });
    }
}